/** Mirror of lambda/lib/what3words.ts. Kept in step with it by hand; the
 *  server normalises venue saves either way, this is for the live link. */
const SHAPE = /^\p{L}[\p{L}'’]*(?:\.\p{L}[\p{L}'’]*){2}$/u;

export function normalizeWhat3Words(input: unknown): string {
  if (typeof input !== 'string') return '';
  let s = input.trim();
  if (!s) return '';
  const url = s.match(/^(?:https?:\/\/)?(?:www\.)?(?:what3words\.com|w3w\.co)\/([^?#\s]+)/i);
  if (url) s = url[1]!.split('/').filter(Boolean).pop() || '';
  s = s.replace(/^\/+/, '').replace(/\/+$/, '').trim().toLowerCase();
  if (s.length > 120) return '';
  return SHAPE.test(s) ? s : '';
}

export function what3WordsUrl(address: string): string {
  const a = normalizeWhat3Words(address);
  return a ? `https://what3words.com/${a}` : '';
}
